import { faMoneyBillSimpleWave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

type AllowanceLineBadgeProps = {
  allowanceType: "unitPrice" | "numberOfProducts";
  quantity: number;
};

export const AllowanceLineBadge = ({
  allowanceType,
  quantity
}: AllowanceLineBadgeProps) => (
  <div className="flex w-fit items-center gap-3 rounded-full bg-kiosk-background-success px-[18px] py-[13px] text-2xl font-bold text-kiosk-text-primary">
    <FontAwesomeIcon icon={faMoneyBillSimpleWave} className="text-[22px]" />
    {allowanceType === "numberOfProducts" ? (
      <T _str="Allowance · {count}×" count={quantity} />
    ) : (
      <T _str="Allowance" />
    )}
  </div>
);
